export default "__VITE_ASSET__D71YVloo__"